export const mediaFilter = (arr) => {
    const sliderData = arr?.map(media => {
        const imgs = (media?.images && media?.images?.flat()) || [];
        const vids = (media?.videos && media?.videos?.flat()) || [];
        return [...imgs, ...vids];
    }
    );
    return sliderData || [];
};